import { getOrganizationSettings } from "./actions/getOrganizationSettings";
import { updateOrganizationSettings } from "./actions/updateOrganizationSettings";

export const actions = {
    getOrganizationSettings,
    updateOrganizationSettings
};
